<template>
    <v-dialog
        v-model="isShow"
        max-width="480"
        persistent
    >
        <v-card>
            <v-toolbar color="primary" dark>
                Підключіть Telegram
            </v-toolbar>

            <v-card-text class="pt-5 text-body-1">
                Підключіть Telegram-бота, щоб отримувати всі сповіщення і нічого не пропустити.
            </v-card-text>

            <v-card-actions class="justify-center pb-6">
                <v-btn
                    color="primary"
                    class="mr-4"
                    :loading="isConnecting"
                    :disabled="isConnecting"
                    @click="connectTelegram"
                >
                    Підключити
                </v-btn>
                <v-btn
                    text
                    :disabled="isConnecting"
                    @click="dismiss"
                >
                    Пізніше
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

const DISMISS_KEY = "telegram-connect-dismissed";

export default {
    name: "TelegramConnectDialog",
    data() {
        return {
            isShow: false,
            isConnecting: false,
        };
    },
    computed: {
        ...mapGetters({
            getProfile: "ProfileModule/getProfile",
            getIsProfileLoaded: "ProfileModule/getIsProfileLoaded",
        }),
    },
    watch: {
        getIsProfileLoaded: {
            immediate: true,
            handler() {
                this.syncVisibility();
            },
        },
        "getProfile.telegram_id"() {
            this.syncVisibility();
        },
    },
    methods: {
        syncVisibility() {
            if (!this.getIsProfileLoaded || this.getProfile.telegram_id) {
                this.isShow = false;
                return;
            }

            this.isShow = sessionStorage.getItem(DISMISS_KEY) !== "1";
        },

        dismiss() {
            sessionStorage.setItem(DISMISS_KEY, "1");
            this.isShow = false;
        },

        connectTelegram() {
            this.isConnecting = true;

            this.axios
                .post("telegram/connect", {})
                .then(response => {
                    if (response.data.data && response.data.data.redirect) {
                        window.open(response.data.data.redirect, "_blank");
                    }
                    this.dismiss();
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.isConnecting = false;
                });
        },
    },
};
</script>
